<default-fp-stats *ngIf="customer !== 'heraeus' && customer !== 'richemont'" [totals]="totals"></default-fp-stats>
<heraeus-fp-stats *ngIf="customer === 'heraeus'" [totals]="totals"></heraeus-fp-stats>
<richemont-fp-stats *ngIf="customer === 'richemont'" [totals]="totals"></richemont-fp-stats>
